import ApiError from '../ApiError.js';
export const ERROR_SERVER_ERROR = 'Server error';
export const ERROR_PARSING_JSON_RESPONSE = 'Error parsing JSON response: ';
export const ERROR_INVALID_RESPONSE = 'Invalid response';
export default async function parseApiResponse(response, onApiError) {
    let data;
    const triggerApiError = (error) => {
        const e = new ApiError(error.m, error.c, response);
        onApiError && onApiError({ error: e });
        return e;
    };
    if (response.ok) {
        try {
            data = await response.json();
        }
        catch (e) {
            throw new Error(ERROR_PARSING_JSON_RESPONSE + e.message);
        }
        if (!data) {
            throw new Error(ERROR_INVALID_RESPONSE);
        }
        if (data.e) {
            throw triggerApiError(data.e);
        }
        if (data.d === undefined) {
            throw new Error(ERROR_INVALID_RESPONSE);
        }
        return data.d;
    }
    else {
        try {
            data = await response.json();
        }
        catch (e) {
            throw new Error(response.statusText);
        }
        if (data && data.e) {
            throw triggerApiError(data.e);
        }
        else {
            throw new Error(ERROR_SERVER_ERROR);
        }
    }
}
export async function parseRawApiResponse(isOk, statusText, parseJson) {
    let data;
    if (isOk) {
        try {
            data = await parseJson();
        }
        catch (e) {
            throw new Error(ERROR_PARSING_JSON_RESPONSE + e.message);
        }
        if (!data) {
            throw new Error(ERROR_INVALID_RESPONSE);
        }
        if (data.e) {
            throw new Error(data.e.m);
        }
        if (data.d === undefined) {
            throw new Error(ERROR_INVALID_RESPONSE);
        }
        return data.d;
    }
    else {
        try {
            data = await parseJson();
        }
        catch (e) {
            throw new Error(statusText);
        }
        if (data && data.e) {
            throw new Error(data.e.m);
        }
        else {
            throw new Error(ERROR_SERVER_ERROR);
        }
    }
}
